import React from 'react';
import { Link } from 'react-router-dom';
import './comingSoon.css';

const ComingSoon = ({ title, description, features, icon }) => {
    return (
        <div className='coming-soon-container'>
            <div className='coming-soon-card'>
                <div className='coming-soon-icon'>{icon}</div>
                <h1>{title}</h1>
                <p className='coming-soon-description'>{description}</p>
                
                <div className='coming-soon-features'>
                    <h3>Geplante Features:</h3>
                    <ul>
                        {features.map((feature, index) => (
                            <li key={index}>{feature}</li>
                        ))}
                    </ul>
                </div>
                
                <div className='coming-soon-status'>
                    <div className='status-badge'>🚧 In Entwicklung</div>
                    <div className='progress-bar'>
                        <div className='progress-fill'></div>
                    </div>
                    <p>⏳ Voraussichtlich verfügbar: Sommer 2026</p>
                </div>
                
                <Link to="/" className='back-button'>← Zurück zu Tools</Link>
            </div>
        </div>
    );
};

export default ComingSoon;